import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Modal,
  TextField,
  Typography,
    CircularProgress,  Stack,
  Dialog,
  DialogTitle,  DialogContent,
  Alert,  DialogActions,

  Snackbar,



} from "@mui/material";
import React from "react";
import { useEffect, useState } from "react"
import {
Table, TableBody, TableCell, TableHead, TableRow,Container, IconButton} from "@mui/material"

import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import Autocomplete from "@mui/material/Autocomplete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";


import Projectcolors from "../../Utils/Colors";
import { InputLabel } from "@mui/material";
import { baseURL } from "../../Config/config";
import SelectKpi from "../Pages/SelectKpi";
import AdminTable from "../CommonC/AdminTable";
import BusinessUsersTable from "../CommonC/BusinessUsersTable";

import AddUserModal from "../CommonC/AddUserModal";
import { Link } from "@mui/material";

import Selexlogo from "../../images/SelexMB Final.png";
import bg from "../../images/AI.jpg";
import Navbar from "../CommonC/SelexSolNavbar";
import BgContainer2 from "../CommonC/BgContainer2";
import GlobalLoader from "../CommonC/GlobalLoader";
import BlogTable from "../CommonC/BlogTable";
import { getBlogs, saveBlogs } from "../../Utils/blogStorage"
import GroupsIcon from "@mui/icons-material/Groups";
import ArticleIcon from "@mui/icons-material/Article";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddIcon from "@mui/icons-material/Add";
import Paper from "@mui/material/Paper";
import AdminNavbar from "../CommonC/AdminNavbar";


import CloseIcon from "@mui/icons-material/Close";


function AdminHome()
{
  const API_BASE_URL = baseURL;

  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [blogs,setBlogs] = useState([])
   const [project,setProect] = useState([])
  const [isEdit, setIsEdit] = React.useState();
  const [BlogsArray, setBlogsArray] = React.useState([]);
  const [ProjectsArray, setProjectsArray] = React.useState([]);
  const [comments, setComments] = React.useState([]);
  const [totalUsers, setTotalUsers] = React.useState(0);
  const [totalProjects, setTotalProjects] = React.useState(0);
  const [newsletters, setNewsletters] = useState([]);


  const [users, setUsers] = useState([]);

  const [openUserModal, setOpenUserModal] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);

  const [level3username, setLevel3Username] = useState("");
  const [level3password, setLevel3Password] = useState("");

  // Comma-separated product IDs entered in the modal.
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [savingUser, setSavingUser] = useState(false);
  const [deletingUserId, setDeletingUserId] = useState(null);
  const [newsletterEmails, setNewsletterEmails] = useState([]);
  const [sendingNewsletterId, setSendingNewsletterId] = useState(null);

const [openEmailDialog, setOpenEmailDialog] = useState(false);

const [editingEmailId, setEditingEmailId] = useState(null);

const [emailForm, setEmailForm] = useState({
  name: "",
  email: "",
});

  const PRODUCT_OPTIONS = [
  "SelexMB Plus",
  "SelexMB Explorer",
  "SelexStudio",
  "SelexModeler",
  "SelexWELL",
  "SelexSEP",
  "SelexAdsorption",
  "SelexMSD",
  "SelexRXN",
  "SelexCAM",
  "SelexICP",
  "SelexICARUS",
  "SelexSWS",
  "SelexRS",
  "SelexDSM",
  "SelexOLE",
  "SelexDMX",
  "SelexFZ",
  "SelexLNG",
  "SelexSRU",
  "SelexLAB",
  "CADENCE",
  "ProCADENCE",
  "SelexPulse",
  "SelexHAZOP",
  "SelexPyramis",
  "SelexAIM",
  "SelexReliability",
  "SelexLEAK",
  "SelexVF",
  "SelexECA",
];

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [getLoader, setGetLoader] = React.useState(false);

  

const fetchNewsletters = async () => {
  try {
    const response = await fetch(
      `${baseURL}/admin/newsletters`,
      {
        credentials: "include",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Unable to fetch newsletters");
    }

    setNewsletters(data.newsletters || []);

  } catch (error) {
    console.error("Fetch newsletters error:", error);
  }
};

const handleSendNewsletter = async (newsletterId) => {
  const confirmed = window.confirm(
    "Are you sure you want to send this newsletter?\n\n" +
    "It will be emailed to all verified subscribed clients.\n" +
    "This action cannot be undone."
  );

  if (!confirmed) return;

  setSendingNewsletterId(newsletterId);

  try {
    const response = await fetch(
      `${baseURL}/admin/newsletters/${newsletterId}/send`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          // Include your existing CSRF token here if required.
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Newsletter sending failed.");
    }

    alert(
      `${data.message}\n\n` +
      `SMTP accepted: ${data.accepted_count}\n` +
      `Failed: ${data.failed_count}\n` +
      `Unresolved: ${data.attempting_count || 0}\n` +
      `Status: ${data.status}`
    );

  } catch (error) {
    console.error("Newsletter sending error:", error);
    alert(error.message);
  } finally {
    setSendingNewsletterId(null);
    await fetchNewsletters();
  }
};

const handleDeleteNewsletter = async (id) => {
  if (!window.confirm("Are you sure you want to delete this newsletter?")) {
    return;
  }

  try {
    const response = await fetch(
      `${baseURL}/admin/newsletters/${id}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Unable to delete newsletter");
    }

    alert(data.message || "Newsletter deleted successfully");

    await fetchNewsletters();

  } catch (error) {
    alert(error.message);
  }
};

  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const closeNotification = () => {
    setNotification((previous) => ({
      ...previous,
      open: false,
    }));
  };

  // Convert "product1, product2, product3" into an array.
  const parseProductIds = (value) => {
    return value
      .split(",")
      .map((productId) => productId.trim())
      .filter(Boolean)
      .filter(
        (productId, index, array) => array.indexOf(productId) === index
      );
  };

const resetUserForm = () => {
  setEditingUserId(null);
  setUsername("");
  setPassword("");

  setSelectedProductIds([]);
};

  const handleOpenAddUserModal = () => {
    resetUserForm();
    setOpenUserModal(true);
  };

  const handleCloseUserModal = () => {
    if (savingUser) return;

    setOpenUserModal(false);
    resetUserForm();
  };

 const handleEditUser = (user) => {
  setEditingUserId(user.user_id);
  console.log(user)

  setLevel3Username(
    user.username || ""
  );

  setLevel3Password( user.unhashedpassword || "");

  setSelectedProductIds(
    Array.isArray(user.product_ids)
      ? user.product_ids
      : []
  );

  setOpenUserModal(true);
};

  const getUsers = async () => {
    try {
      setLoadingUsers(true);

      const response = await fetch(
        `${API_BASE_URL}/admin/level3-users`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to load users.");
      }

      /*
        Supported backend responses:

        1. Direct array:
           [
             {
               user_id: "...",
               username: "...",
               product_ids: ["product-1", "product-2"]
             }
           ]

        2. Object:
           {
             users: [...]
           }
      */

      setUsers(Array.isArray(data) ? data : data.users || []);
      console.log(data.users)
    } catch (error) {
      console.error("Get users error:", error);
      showNotification(error.message || "Unable to load users.", "error");
    } finally {
      setLoadingUsers(false);
    }
  };

  const validateUserForm = () => {
    const cleanUsername = level3username.trim();
    const productIds = selectedProductIds;
    if (!cleanUsername) {
      showNotification("Please enter a username.", "error");
      return false;
    }

    // Password is required only while creating a new user.
    if (!editingUserId && !level3password.trim()) {
      showNotification("Please enter a password.", "error");
      return false;
    }

    if (productIds.length === 0) {
      showNotification(
        "Please enter at least one product ID.",
        "error"
      );
      return false;
    }

    return true;
  };

  const handleSaveUser = async () => {
  if (!level3username.trim()) {
    showNotification(
      "Please enter a username.",
      "error"
    );
    return;
  }

  if (!editingUserId && !level3password.trim()) {
    showNotification(
      "Please enter a password.",
      "error"
    );
    return;
  }

  if (selectedProductIds.length === 0) {
    showNotification(
      "Please select at least one product.",
      "error"
    );
    return;
  }

  const payload = {
    username: level3username.trim(),

    product_ids: selectedProductIds,
  };

  if (level3password.trim()) {
    payload.password = level3password;
  }

  const isEditing = Boolean(editingUserId);

  const endpoint = isEditing
    ? `${baseURL}/admin/level3-users/${editingUserId}`
    : `${baseURL}/admin/level3-users`;

  try {
    setSavingUser(true);

    const response = await fetch(endpoint, {
      method: isEditing ? "PUT" : "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.message ||
          `Unable to ${
            isEditing ? "update" : "create"
          } user.`
      );
    }

    showNotification(
      isEditing
        ? "User updated successfully."
        : "User created successfully."
    );

    setOpenUserModal(false);

    resetUserForm();

    await getUsers();

  } catch (error) {
    console.error(
      "Save user error:",
      error
    );

    showNotification(
      error.message || "Unable to save user.",
      "error"
    );

  } finally {
    setSavingUser(false);
  }
};

  const handleDeleteUser = async (user) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${user.username}"?`
    );

    if (!confirmed) return;

    try {
      setDeletingUserId(user.user_id);

      const response = await fetch(
        `${API_BASE_URL}/admin/level3-users/${user.user_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to delete user.");
      }

      setUsers((previousUsers) =>
        previousUsers.filter(
          (existingUser) => existingUser.user_id !== user.user_id
        )
      );

      showNotification("User deleted successfully.");
    } catch (error) {
      console.error("Delete user error:", error);
      showNotification(error.message || "Unable to delete user.", "error");
    } finally {
      setDeletingUserId(null);
    }
  };
  
  
 const deleteBlog = async (id) => {
     const body = {
       blog_id: id,
     };
 
     const options = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify(body),
     };
 
     try {
       //setLoader(true)
       let result = await fetch(`${baseURL}/deleteblog`, options);
       result = await result.json();
       if (result.code) {
         // setPageUpdater(pageUpdater + 1)
         // window.location.reload();
         await getAllBlogs()
         //setLoader(false)
         return;
       }
       alert("There was some error");
       //setLoader(false)
     } catch (error) {
       //setLoader(false)
       console.log("error", error);
     }
   };

   const deleteProject = async (id) => {
     const body = {
       project_id: id,
     };
 
     const options = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify(body),
     };
 
     try {
       //setLoader(true)
       let result = await fetch(`${baseURL}/deleteoptimizeproject`, options);
       result = await result.json();
       if (result.code) {
         // setPageUpdater(pageUpdater + 1)
         // window.location.reload();
         await getAllProjects()
         //setLoader(false)
         return;
       }
       //alert("There was some error");
       //setLoader(false)
     } catch (error) {
       //setLoader(false)
       console.log("error", error);
     }
   };


    const deleteComment = async (id) => {
     const body = {
       comment_id: id,
     };
 
     const options = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify(body),
     };
 
     try {
       //setLoader(true)
       let result = await fetch(`${baseURL}/deletecomment`, options);
       result = await result.json();
       if (result.code) {
         // setPageUpdater(pageUpdater + 1)
         // window.location.reload();
         await getComments()
         //setLoader(false)
         return;
       }
       //alert("There was some error");
       //setLoader(false)
     } catch (error) {
       //setLoader(false)
       console.log("error", error);
     }
   };
  const toggleModal = (value) => {
    setModalState(value);
  };


  const handleOpenEmailDialog = (client = null) => {
  if (client) {
    setEditingEmailId(client.id);
    setEmailForm({
      name: client.name,
      email: client.email,
    });
  } else {
    setEditingEmailId(null);
    setEmailForm({
      name: "",
      email: "",
    });
  }

  setOpenEmailDialog(true);
};


const fetchNewsletterEmails = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/admin/newsletter/subscribers`,
      {
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch subscribers");
    }

    const data = await response.json();

    setNewsletterEmails(data.subscribers || []);

  } catch (error) {
    console.error("Error fetching newsletter emails:", error);
  }
};
  useEffect(async () => {
    await getAllBlogs();
    await getUsers();
     await getAllProjects();
     await getComments();
      await fetchNewsletterEmails();
       await fetchNewsletters();


  }, []);

  const getAllBlogs = async () => {
      try {
        setGetLoader(true);
        let result = await fetch(`${baseURL}/getallcompleteblogs`);
        result = await result.json();
        if (result.code) {
          const blogdata = [];
          setIsEdit([])
          result.data.map((item, idx) => {
            //setLoader(false)
            return blogdata.push({
              id: item.blog_id,        
              title:item.title,
              slug:item.slug,
              description:item.description,
              author:item.author,
              date:item.date,
              image:item.image,
              content:item.content,
              editBlogState: false,
            });
          });
          setIsEdit(blogdata);
          //setLoader(false)
          setBlogsArray(result.data);
  
          return;
        }
        alert("There was some error");
        //setLoader(false)
      } catch (error) {
        //setLoader(false)
        console.log("error", error);
      }
    };


     const getAllProjects = async () => {
      try {
        //setLoader(true)
        let result = await fetch(`${baseURL}/getallprojects`);
        result = await result.json();
        if (result.code) {
          const projectdata = [];
          setIsEdit([])
          result.data.map((item, idx) => {
            //setLoader(false)
            return projectdata.push({
              id: item.project_id,        
              title:item.title,
              slug:item.slug,
              description:item.description,
              author:item.author,
              date:item.date,
              image:item.image,
              content:item.content,
              editProjectState: false,
            });
          });
          setIsEdit(projectdata);
          setTotalProjects(result.data.length);
          //setLoader(false)
          setProjectsArray(result.data);
  
          return;
        }
        alert("There was some error");
        //setLoader(false)
      } catch (error) {
        //setLoader(false)
        console.log("error", error);
      }
    };


    const handleSaveEmail = async () => {
  const name = emailForm.name.trim();
  const email = emailForm.email.trim().toLowerCase();

  if (!name || !email) {
    alert("Please enter name and email.");
    return;
  }

  const isEditing = editingEmailId !== null;

  const url = isEditing
    ? `${baseURL}/admin/newsletter/subscribers/${editingEmailId}`
    : `${baseURL}/admin/newsletter/subscribers`;

  try {
    const response = await fetch(url, {
      method: isEditing ? "PUT" : "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, email }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Unable to save email.");
    }

    alert(data.message);

    setOpenEmailDialog(false);
    setEditingEmailId(null);
    setEmailForm({ name: "", email: "" });

    await fetchNewsletterEmails();

  } catch (error) {
    alert(error.message);
  }
};

const handleDeleteEmail = async (id) => {
  if (!window.confirm("Delete this subscriber?")) {
    return;
  }

  try {
    const response = await fetch(
      `${baseURL}/admin/newsletter/subscribers/${id}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Unable to delete subscriber.");
    }

    alert(data.message);

    await fetchNewsletterEmails();

  } catch (error) {
    alert(error.message);
  }
};


    const getComments = async ()=>{
    
    let res = await fetch(`${baseURL}/getallcomments`)
    res = await res.json()
    
    setComments(res.comments)
    setGetLoader(false);
    
    }

return (
  <Box
    sx={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #eef4fb, #dfeaf7)",
      pb: 5,
    }}
  >
    <AdminNavbar isLoggedIn={sessionStorage.getItem('adminlogin')} />

    {/* HEADER */}
    <Box
      sx={{
        px: 5,
        pt: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <DashboardIcon
          sx={{
            color: Projectcolors.primary,
            fontSize: 34,
          }}
        />

        <Typography
          sx={{
            fontSize: 32,
            fontWeight: 700,
            color: "#1e293b",
          }}
        >
          Admin Dashboard
        </Typography>
      </Box>

      <Typography
        sx={{
          color: "#64748b",
          mt: 1,
          fontSize: 14,
        }}
      >
        Manage users, blogs and platform activities
      </Typography>
    </Box>

    {/* STATS */}
    <Box
      sx={{
        px: 5,
        mt: 4,
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "1fr 1fr 1fr",
        },
        gap: 3,
      }}
    >
      {/* USERS */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: "18px",
          background:
            "linear-gradient(135deg, #0f6cbd 0%, #3ea6ff 100%)",
          color: "white",
          boxShadow: "0 10px 25px rgba(15,108,189,0.25)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ opacity: 0.9, fontSize: 14 }}>
              Total Users
            </Typography>

            <Typography
              sx={{
                fontSize: 38,
                fontWeight: 700,
                mt: 1,
              }}
            >
              {totalUsers}
            </Typography>
          </Box>

          <GroupsIcon sx={{ fontSize: 55, opacity: 0.8 }} />
        </Box>
      </Paper>

      {/* BLOGS */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: "18px",
          background:
            "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)",
          color: "white",
          boxShadow: "0 10px 25px rgba(124,58,237,0.25)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ opacity: 0.9, fontSize: 14 }}>
              Total Blogs
            </Typography>

            <Typography
              sx={{
                fontSize: 38,
                fontWeight: 700,
                mt: 1,
              }}
            >
              {BlogsArray.length}
            </Typography>
          </Box>

          <ArticleIcon sx={{ fontSize: 55, opacity: 0.8 }} />
        </Box>
      </Paper>

      {/* PROJECTS */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: "18px",
          background:
            "linear-gradient(135deg, #059669 0%, #10b981 100%)",
          color: "white",
          boxShadow: "0 10px 25px rgba(5,150,105,0.25)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ opacity: 0.9, fontSize: 14 }}>
              Total Projects
            </Typography>

            <Typography
              sx={{
                fontSize: 38,
                fontWeight: 700,
                mt: 1,
              }}
            >
              {totalProjects}
            </Typography>
          </Box>

          <FolderCopyIcon sx={{ fontSize: 55, opacity: 0.8 }} />
        </Box>
      </Paper>



    </Box>

    {/* MAIN CONTENT */}
    <Box
      sx={{
        px: 5,
        mt: 4,
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          lg: "1fr 1.2fr",
        },
        gap: 3,
        alignItems: "start",
      }}
    >
      {/* USERS TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
      
        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <AdminTable
            modalState={modalState}
            toggleModal={toggleModal}
            setTotalUsers={setTotalUsers}
          />
        </Box>
      </Paper>

      {/* BLOG TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            background: "#f8fafc",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#1e293b",
            }}
          >
            Blog Control
          </Typography>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate("/admin/blogs/add")}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              background:
                "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
              boxShadow: "none",
            }}
          >
            Add Blog
          </Button>
        </Box>

        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                fontSize: "13px",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f1f5f9",
                }}
              >
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Author</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Edit</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {BlogsArray.map((blog) => (
                <TableRow
                  key={blog.blog_id}
                  hover
                >
                  <TableCell>
                    {blog.blog_id
                      ? blog.blog_id.slice(0, 4) + "..."
                      : ""}
                  </TableCell>

                  <TableCell>{blog.title}</TableCell>

                  <TableCell>{blog.author}</TableCell>

                  <TableCell>{blog.date}</TableCell>

                  <TableCell>
                    <img
                      src={blog.image}
                      width="70"
                      style={{
                        borderRadius: "8px",
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <IconButton
                      onClick={() =>
                        navigate(
                          `/admin/blogs/edit/${blog.blog_id}`
                        )
                      }
                    >
                      <EditIcon
                        sx={{
                          color: "#2563eb",
                        }}
                      />
                    </IconButton>
                  </TableCell>

                  <TableCell>
                    <IconButton
                      onClick={() =>
                        deleteBlog(blog.blog_id)
                      }
                    >
                      <DeleteIcon
                        sx={{
                          color: "#dc2626",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Paper>


       {/* PROJECT TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            background: "#f8fafc",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#1e293b",
            }}
          >
            Project Management
          </Typography>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate("/admin/projects/add")}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              background:
                "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
              boxShadow: "none",
            }}
          >
            Add Project
          </Button>
        </Box>

        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                fontSize: "13px",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f1f5f9",
                }}
              >
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Author</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Edit</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {ProjectsArray.map((proj) => (
                <TableRow
                  key={proj.project_id}
                  hover
                >
                  <TableCell>
                    {proj.project_id
                      ? proj.project_id.slice(0, 4) + "..."
                      : ""}
                  </TableCell>

                  <TableCell>{proj.title}</TableCell>

                  <TableCell>{proj.author}</TableCell>

                  <TableCell>{proj.date}</TableCell>

                  <TableCell>
                    <img
                      src={proj.image}
                      width="70"
                      style={{
                        borderRadius: "8px",
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <IconButton
                      onClick={() =>
                        navigate(
                          `/admin/projects/edit/${proj.project_id}`
                        )
                      }
                    >
                      <EditIcon
                        sx={{
                          color: "#2563eb",
                        }}
                      />
                    </IconButton>
                  </TableCell>

                  <TableCell>
                    <IconButton
                      onClick={() =>
                        deleteProject(proj.project_id)
                      }
                    >
                      <DeleteIcon
                        sx={{
                          color: "#dc2626",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Paper>


         {/* Comments TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            background: "#f8fafc",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#1e293b",
            }}
          >
            Comments Management
          </Typography>

         
        </Box>

        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <Table
            sx={{
              "& .MuiTableCell-root": {
                fontSize: "13px",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f1f5f9",
                }}
              >
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {comments.map((comment) => (
                <TableRow
                  key={comment.comment_id}
                  hover
                >
                  <TableCell>
                    {comment.comment_id
                      ? comment.comment_id.slice(0, 4) + "..."
                      : ""}
                  </TableCell>

                  <TableCell>{comment.name}</TableCell>

                  <TableCell>{comment.email}</TableCell>

                  <TableCell>{comment.date}</TableCell>
                   <TableCell>{comment.comment}</TableCell>



                  <TableCell>
                    <IconButton
                      onClick={() =>
                        deleteComment(comment.comment_id)
                      }
                    >
                      <DeleteIcon
                        sx={{
                          color: "#dc2626",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Paper>


      {/* Level 3 User Management Table */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        {/* Table Header */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            background: "#f8fafc",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: "#1e293b",
              }}
            >
              User Management for Level 3 Apps
            </Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: 13,
                color: "#64748b",
              }}
            >
              Create users and assign access to one or more products.
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenAddUserModal}
            sx={{
              borderRadius: "10px",
              px: 2.5,
              textTransform: "none",
              background:
                "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
                background:
                  "linear-gradient(90deg, #095b9d 0%, #228bc3 100%)",
              },
            }}
          >
            Add User
          </Button>
        </Box>

        {/* Table Container */}
        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflow: "auto",
          }}
        >
          <Table
            stickyHeader
            sx={{
              minWidth: 850,
              "& .MuiTableCell-root": {
                fontSize: "13px",
                borderColor: "#e5e7eb",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                    width: 90,
                  }}
                >
                  ID
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                  }}
                >
                  Username
                </TableCell>
                 <TableCell
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                  }}
                >
                  Password
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                    minWidth: 100,
                  }}
                >
                  Product Access
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                    width: 90,
                  }}
                >
                  Edit
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#f1f5f9",
                    fontWeight: 700,
                    color: "#334155",
                    width: 90,
                  }}
                >
                  Delete
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loadingUsers ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                    <CircularProgress size={30} />

                    <Typography
                      sx={{
                        mt: 1.5,
                        fontSize: 13,
                        color: "#64748b",
                      }}
                    >
                      Loading users...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                    <Typography
                      sx={{
                        color: "#64748b",
                        fontSize: 14,
                      }}
                    >
                      No users have been added yet.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user, index) => (
                  <TableRow
                    key={user.user_id || index}
                    hover
                    sx={{
                      "&:last-child td": {
                        borderBottom: 0,
                      },
                    }}
                  >
                    <TableCell>
                      {user.user_id
                        ? `${String(user.user_id).slice(0, 6)}...`
                        : index + 1}
                    </TableCell>

                    <TableCell>
                      <Typography
                        sx={{
                          fontSize: 13,
                          color: "#1e293b",
                        }}
                      >
                        {user.username}
                      </Typography>
                    </TableCell>
                      <TableCell>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#1e293b",
                        }}
                      >
                        {user.unhashedpassword}
                      </Typography>
                    </TableCell>

                    {/*
                      Never display the real password from the database.

                      The backend should save a hashed password, not a plain
                      password.
                    */}
          
                    <TableCell>
                      <Stack
                        direction="row"
                        spacing={0.75}
                        useFlexGap
                        flexWrap="wrap"
                      >
                        {Array.isArray(user.product_ids) &&
                        user.product_ids.length > 0 ? (
                          user.product_ids.map((productId) => (
                            <Chip
                              key={productId}
                              label={productId}
                              size="small"
                              sx={{
                                borderRadius: "7px",
                                backgroundColor: "#e0f2fe",
                                color: "#0369a1",
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            />
                          ))
                        ) : (
                          <Typography
                            sx={{
                              fontSize: 12,
                              color: "#94a3b8",
                            }}
                          >
                            No products assigned
                          </Typography>
                        )}
                      </Stack>
                    </TableCell>

                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={() => handleEditUser(user)}
                        sx={{                          "&:hover": {
                            backgroundColor: "#dbeafe",
                          },
                        }}
                      >
                        <EditIcon
                          sx={{
                            color: "#2563eb",
                          }}
                        />
                      </IconButton>
                    </TableCell>

                    <TableCell align="center">
                      <IconButton
                        size="small"
                        disabled={deletingUserId === user.user_id}
                        onClick={() => handleDeleteUser(user)}
                        sx={{
                          
                          "&:hover": {
                            backgroundColor: "#fee2e2",
                          },
                        }}
                      >
                        {deletingUserId === user.user_id ? (
                          <CircularProgress size={17} />
                        ) : (
                          <DeleteIcon
                            sx={{
                              color: "#dc2626",
                            }}
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </Paper>

      {/* Add / Edit User Modal */}
      <Dialog
        open={openUserModal}
        onClose={handleCloseUserModal}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "18px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #e5e7eb",
              backgroundColor: "#f8fafc",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 700,
                  color: "#1e293b",
                }}
              >
                {editingUserId ? "Edit User" : "Add New User"}
              </Typography>

              <Typography
                sx={{
                  mt: 0.4,
                  fontSize: 12,
                  color: "#64748b",
                }}
              >
                Assign one or more Level 3 product IDs.
              </Typography>
            </Box>

            <IconButton
              onClick={handleCloseUserModal}
              disabled={savingUser}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

       <DialogContent
  sx={{
    px: 3,
    py: 4,
    pt: 5,
    overflow: "visible",
    marginTop:3
  }}
>
  <Stack spacing={4}>
    {/* USERNAME */}
    <TextField
      label="Username"
      value={level3username}
      onChange={(event) => setLevel3Username(event.target.value)}
      fullWidth
      required
      autoFocus
      placeholder="Enter username"
      inputProps={{
        maxLength: 100,
        fontSize:16
      }}
      InputLabelProps={{
        sx: {
          color: "#64748b",

          "&.Mui-focused": {
            color: "#0b6cb8",
          },

          "&.MuiInputLabel-shrink": {
            backgroundColor: "#fff",
            px: "5px",
          },
        },
      }}
      sx={{
         "& .MuiInputBase-input": {
      fontSize: 14,
    },

   
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",

          "& fieldset": {
            borderColor: "#d1d5db",
          },

          "&:hover fieldset": {
            borderColor: "#94a3b8",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#0b6cb8",
          },
        },
      }}
    />

    {/* PASSWORD */}
    <TextField
      label={editingUserId ? "New Password" : "Password"}
      value={level3password}
      onChange={(event) => setLevel3Password(event.target.value)}
      fullWidth
      required={!editingUserId}
      placeholder={
        editingUserId
          ? "Leave blank to keep the existing password"
          : "Enter password"
      }
      inputProps={{
        maxLength: 200,
        fontSize:16
      }}
      InputLabelProps={{
        sx: {
          color: "#64748b",

          "&.Mui-focused": {
            color: "#0b6cb8",
          },

          "&.MuiInputLabel-shrink": {
            backgroundColor: "#fff",
            px: "5px",
          },
        },
      }}
      sx={{
         "& .MuiInputBase-input": {
      fontSize: 14,
    },

  
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",

          "& fieldset": {
            borderColor: "#d1d5db",
          },

          "&:hover fieldset": {
            borderColor: "#94a3b8",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#0b6cb8",
          },
        },
      }}
    />

    {/* PRODUCT ACCESS */}
    <Autocomplete
      multiple
      options={PRODUCT_OPTIONS}
      value={selectedProductIds}
      onChange={(event, newValue) => {
        setSelectedProductIds(newValue);
      }}
      disableCloseOnSelect
      filterSelectedOptions
      fullWidth

      slotProps={{
        popper: {
          placement: "bottom-start",

          modifiers: [
            {
              name: "flip",
              enabled: false,
            },

            {
              name: "preventOverflow",
              options: {
                altAxis: false,
                tether: false,
              },
            },
          ],
        },

        paper: {
          sx: {
            mt: 1,
            borderRadius: "10px",
            boxShadow:
              "0 10px 30px rgba(0,0,0,0.12)",
            border: "1px solid #e5e7eb",
          },
        },
      }}

      renderTags={(value, getTagProps) =>
        value.map((productId, index) => (
          <Chip
            label={productId}
            {...getTagProps({ index })}
            key={productId}
            sx={{
              backgroundColor: "#e0f2fe",
              color: "#0369a1",
              fontWeight: 600,
              borderRadius: "7px",
            }}
          />
        ))
      }

      renderInput={(params) => (
        <TextField
          {...params}
          label="Product Access"
          placeholder={
            selectedProductIds.length === 0
              ? "Select one or more products"
              : "Add another product"
          }
          required={selectedProductIds.length === 0}

          InputLabelProps={{
            ...params.InputLabelProps,

            sx: {
              color: "#64748b",

              "&.Mui-focused": {
                color: "#0b6cb8",
              },

              "&.MuiInputLabel-shrink": {
                backgroundColor: "#fff",
                px: "5px",
              },
            },
          }}
        />
      )}

      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          alignItems: "flex-start",
          py: 0.5,

          "& fieldset": {
            borderColor: "#d1d5db",
          },

          "&:hover fieldset": {
            borderColor: "#94a3b8",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#0b6cb8",
          },
        },
      }}
    />
  </Stack>
</DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid #e5e7eb",
            backgroundColor: "#f8fafc",
          }}
        >
          <Button
            onClick={handleCloseUserModal}
            disabled={savingUser}
            sx={{
              borderRadius: "9px",
              px: 2.5,
              textTransform: "none",
              color: "#475569",
              fontSize:10
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSaveUser}
            disabled={savingUser}
            sx={{
              minWidth: 120,
              borderRadius: "9px",
              px: 2.5,
              textTransform: "none",
              fontSize:10,
              background:
                "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
                background:
                  "linear-gradient(90deg, #095b9d 0%, #228bc3 100%)",
              },
            }}
          >
            {savingUser ? (
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            ) : editingUserId ? (
              "Update User"
            ) : (
              "Add User"
            )}
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
  open={openEmailDialog}
  onClose={() => setOpenEmailDialog(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>
    {editingEmailId !== null
      ? "Edit Client Email"
      : "Add Client Email"}
  </DialogTitle>

  <DialogContent>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
      <TextField
        label="Client Name"
        fullWidth
        value={emailForm.name}
        onChange={(e) =>
          setEmailForm((prev) => ({
            ...prev,
            name: e.target.value,
          }))
        }
      />

      <TextField
        label="Email Address"
        type="email"
        fullWidth
        value={emailForm.email}
        onChange={(e) =>
          setEmailForm((prev) => ({
            ...prev,
            email: e.target.value,
          }))
        }
      />
    </Box>
  </DialogContent>

  <DialogActions sx={{ p: 3 }}>
    <Button onClick={() => setOpenEmailDialog(false)}>
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleSaveEmail}
    >
      {editingEmailId !== null ? "Update Email" : "Save Email"}
    </Button>
  </DialogActions>
</Dialog>

      {/* Success / Error Message */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={closeNotification}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={closeNotification}
          severity={notification.severity}
          variant="filled"
          sx={{
            width: "100%",
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>


         {/* Business Users TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
      
        <Box
          sx={{
            p: 2,
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <BusinessUsersTable
            modalState={modalState}
            toggleModal={toggleModal}
            setTotalUsers={setTotalUsers}
          />
        </Box>
      </Paper>


      {/* NEWSLETTER SUBSCRIBERS TABLE */}
<Paper
  elevation={0}
  sx={{
    mt: 4,
    borderRadius: "18px",
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
  }}
>
  <Box
    sx={{
      px: 3,
      py: 2,
      borderBottom: "1px solid #e5e7eb",
      background: "#f8fafc",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Box>
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 600,
          color: "#1e293b",
        }}
      >
        Newsletter Subscribers
      </Typography>

      <Typography
        sx={{
          fontSize: 13,
          color: "#64748b",
          mt: 0.5,
        }}
      >
        Manage client email addresses for newsletters
      </Typography>
    </Box>

    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={() => handleOpenEmailDialog()}
      sx={{
        borderRadius: "10px",
        textTransform: "none",
        background:
          "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
        boxShadow: "none",
      }}
    >
      Add Email
    </Button>
  </Box>

  <Box
    sx={{
      p: 2,
      maxHeight: "65vh",
      overflowY: "auto",
      overflowX: "auto",
    }}
  >
    <Table
      sx={{
        "& .MuiTableCell-root": {
          fontSize: "13px",
        },
      }}
    >
      <TableHead>
        <TableRow sx={{ backgroundColor: "#f1f5f9" }}>
          <TableCell>ID</TableCell>
          <TableCell>Client Name</TableCell>
          <TableCell>Email Address</TableCell>
          <TableCell>Date Added</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Date Unsubscribed</TableCell>

          <TableCell>Edit</TableCell>
          <TableCell>Delete</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {newsletterEmails.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} align="center">
              <Typography
                sx={{
                  color: "#64748b",
                  py: 3,
                }}
              >
                No newsletter emails added yet.
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          newsletterEmails.map((client, index) => (
            <TableRow key={client.id} hover>
              <TableCell>{index + 1}</TableCell>

              <TableCell>{client.name}</TableCell>

              <TableCell>{client.email}</TableCell>

              <TableCell>{client.date}</TableCell>

              <TableCell>
  <Chip
    label={
      client.status === "unsubscribed"
        ? "Unsubscribed"
        : "Subscribed"
    }
    size="small"
    sx={{
      backgroundColor:
        client.status === "unsubscribed"
          ? "#fee2e2"
          : "#dcfce7",
      color:
        client.status === "unsubscribed"
          ? "#b91c1c"
          : "#166534",
      fontWeight: 600,
    }}
  />
</TableCell>

<TableCell>
  {client.unsubscribed_at
    ? new Date(client.unsubscribed_at).toLocaleString()
    : "—"}
</TableCell>

              <TableCell>
                <IconButton
                  onClick={() =>
                    handleOpenEmailDialog(client)
                  }
                >
                  <EditIcon
                    sx={{ color: "#2563eb" }}
                  />
                </IconButton>
              </TableCell>

              <TableCell>
                <IconButton
                  onClick={() =>
                    handleDeleteEmail(client.id)
                  }
                >
                  <DeleteIcon
                    sx={{ color: "#dc2626" }}
                  />
                </IconButton>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </Box>
</Paper>

{/* NEWSLETTER CONTROL TABLE */}
<Paper
  elevation={0}
  sx={{
    mt: 4,
    borderRadius: "18px",
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
  }}
>
  <Box
    sx={{
      px: 3,
      py: 2,
      borderBottom: "1px solid #e5e7eb",
      background: "#f8fafc",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: 20,
        fontWeight: 600,
        color: "#1e293b",
      }}
    >
      Newsletter Control
    </Typography>

    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={() => navigate("/admin/newsletter/add")}
      sx={{
        borderRadius: "10px",
        textTransform: "none",
        background:
          "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
        boxShadow: "none",
      }}
    >
      Create Newsletter
    </Button>
  </Box>

  <Box sx={{ p: 2, maxHeight: "65vh", overflow: "auto" }}>
    <Table
      sx={{
        "& .MuiTableCell-root": {
          fontSize: "13px",
        },
      }}
    >
      <TableHead>
        <TableRow sx={{ backgroundColor: "#f1f5f9" }}>
          <TableCell>ID</TableCell>
          <TableCell>Subject</TableCell>
          <TableCell>Created Date</TableCell>
          <TableCell>Recipients</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Preview</TableCell>
          <TableCell>Edit</TableCell>
          <TableCell>Send</TableCell>
          <TableCell>Delete</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {newsletters.length === 0 ? (
          <TableRow>
            <TableCell colSpan={9} align="center">
              <Typography sx={{ color: "#64748b", py: 3 }}>
                No newsletters created yet.
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          newsletters.map((item, index) => (
            <TableRow key={item.id} hover>
              <TableCell>{index + 1}</TableCell>

              <TableCell>{item.subject}</TableCell>

              <TableCell>{item.created_at}</TableCell>

              <TableCell>
                {item.recipient_count ?? "—"}
              </TableCell>

              <TableCell>
               <Chip
  label={
    {
      draft: "Draft",
      sending: "Sending",
      sent: "Sent",
      partially_sent: "Partially Sent",
      failed: "Failed"
    }[item.status] || item.status
  }
  size="small"
  color={
    item.status === "sent"
      ? "success"
      : item.status === "failed"
      ? "error"
      : item.status === "sending"
      ? "info"
      : item.status === "partially_sent"
      ? "warning"
      : "default"
  }
  variant="outlined"
/>
              </TableCell>

        
             {/* PREVIEW */}
<TableCell align="center">
  <IconButton
    title="Preview Newsletter"
    onClick={() =>
      window.open(
        `/admin/newsletter/preview/${item.id}`,
        "_blank",
        "noopener,noreferrer"
      )
    }
  >
    <VisibilityIcon sx={{ color: "#0078c9" }} />
  </IconButton>
</TableCell>

{/* EDIT */}
<TableCell align="center">
  <IconButton
    title={
      item.status === "draft"
        ? "Edit Newsletter"
        : "Only draft newsletters can be edited"
    }
    disabled={item.status !== "draft"}
    onClick={() =>
      navigate(`/admin/newsletter/edit/${item.id}`)
    }
  >
    <EditIcon
      sx={{
        color:
          item.status === "draft"
            ? "#0078c9"
            : "#9ca3af",
      }}
    />
  </IconButton>
</TableCell>

              <TableCell>
                <Button
  size="small"
  variant="contained"
  disabled={
    item.status !== "draft" ||
    sendingNewsletterId !== null
  }
  onClick={() => handleSendNewsletter(item.id)}
  sx={{
    textTransform: "none",
    borderRadius: "8px",
    background: "#0078c9",
    "&:hover": {
      background: "#005e9e"
    }
  }}
>
  {sendingNewsletterId === item.id
    ? "Sending..."
    : "Send"}
</Button>
              </TableCell>
<TableCell>
  <IconButton
    onClick={() => handleDeleteNewsletter(item.id)}
    title="Delete newsletter"
  >
    <DeleteIcon sx={{ color: "#dc2626" }} />
  </IconButton>
</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </Box>
</Paper>

    </Box>
  
   {getLoader ? <GlobalLoader /> : null}
  </Box>
);
};

export default AdminHome
